import axios from "axios";
import { headerConfig } from "../utility/RequestHeaderConfig";
import { BASE_API_URL, BASE_LOGIN_API_URL } from "../utility/URL";


const accountGroupList = async () => {
    const response = await axios
        .post(BASE_API_URL + "account/accountgroup",{}, headerConfig);
    return response;
};

const accountGroupTreeList = async () => {
    const response = await axios
        .post(BASE_API_URL + "account/account-group-tree",{}, headerConfig);
    return response;
};


const accountGroupTopParent = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "account/group-top-partent",data, headerConfig);
    return response;
};

const accountGroupDetailById = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "account/groupedit",data, headerConfig);
    return response;
};

const accountGroupSave = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "account/groupaction", data, headerConfig);
        return response.data;
  };

const subCategoryByCategoryList = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "account/subgroupbycat",data, headerConfig);
    return response;
};


const accountList = async () => {
    const response = await axios
        .post(BASE_API_URL + "account/list",{}, headerConfig);
    return response;
};

const accountProfitAndIncomeList = async () => {
    const response = await axios
        .post(BASE_API_URL + "account/list-pli",{}, headerConfig);
    return response;
};

const accountSave = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "account/action", data, headerConfig);
        return response.data;
  };

const gstList = async () => {
    const response = await axios
        .post(BASE_API_URL + "account/gstlist",{}, headerConfig);
    return response;
};


const gstSave = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "account/gstaction", data, headerConfig);
        return response.data;
  };

  const gstListByInputType = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "account/gstlist-usedfor",data, headerConfig);
    return response;
};


  const paymentModeList = async () => {
    const response = await axios
        .post(BASE_API_URL + "account/payment-mode-list",{}, headerConfig);
    return response;
};

const paymentModeSave = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "account/payment-mode-action", data, headerConfig);
        return response.data;
  };


  const voucherList = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "account/report-voucher-register", data, headerConfig);
        return response.data;
  };


  const deleteGroup = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "account/group-delete", data, headerConfig);
        return response.data;
  };

  const deleteAccount = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "account/account-delete", data, headerConfig);
        return response.data;
  };


  const accountListForContra = async () => {
    const response = await axios
        .post(BASE_API_URL + "account/list-cashbank",{}, headerConfig);
    return response;
    };





    const contraVoucherSave = async (data) => {
        const response = await axios
            .post(BASE_API_URL + "account/contra-voucher", data, headerConfig);
            return response.data;
    };


    const contraVoucherEditByID = async (data) => {
        const response = await axios
            .post(BASE_API_URL + "account/contra-voucher-edit-data", data, headerConfig);
            return response.data;
    };

    

    const multipleVoucherDataByID = async (data) => {
        const response = await axios
            .post(BASE_API_URL + "account/multiple-voucher-edit-data", data, headerConfig);
            return response.data;
    };

    const voucherListByTag = async (data) => {
        const response = await axios
            .post(BASE_API_URL + "account/voucher-list-by-tag", data, headerConfig);
            return response.data;
      };

      const journalVoucherSave = async (data) => {
        const response = await axios
            .post(BASE_API_URL + "account/journal-voucher", data, headerConfig);
            return response.data;
    };

    const accountListForJournal = async () => {
        const response = await axios
            .post(BASE_API_URL + "account/list-not-cashbank",{}, headerConfig);
        return response;
        };


    const generalVoucherSave = async (data) => {
        const response = await axios
                .post(BASE_API_URL + "account/general-voucher", data, headerConfig);
                return response.data;
    };
    
    const generalVoucherEditData = async (data) => {
        const response = await axios
                .post(BASE_API_URL + "account/general-voucher-edit-data", data, headerConfig);
                return response.data;
    };

    const vendorList = async (data) => {
        const response = await axios
                .post(BASE_API_URL + "account/get-vendor-list", data, headerConfig);
                return response.data;
    };

    const customerList = async (data) => {
        const response = await axios
                .post(BASE_API_URL + "account/customer-list", data, headerConfig);
                return response.data;
    };

    const stateList = async (data) => {
        const response = await axios
                .post(BASE_API_URL + "account/state-list", data, headerConfig);
                return response.data;
    };


    // Except Creditor , Debitor
    const accountListExceptCD = async () => {
        const response = await axios
            .post(BASE_API_URL + "account/account-without-cd",{}, headerConfig);
        return response;
    };

    const bankList = async () => {
        const response = await axios
            .post(BASE_API_URL + "programme/bank-list",{}, headerConfig);
        return response;
    };

    const deletePaymentMode = async (data) => {
        const response = await axios
            .post(BASE_API_URL + "delete/payment-mode", data, headerConfig);
            return response.data;
      };
    

const accountService = {
    accountGroupList,
    accountGroupTreeList,
    accountGroupTopParent,
    accountGroupDetailById,

    accountGroupSave,

    subCategoryByCategoryList,

    accountList,
    accountProfitAndIncomeList,
    accountSave,
    
    gstList,
    gstSave,
    gstListByInputType,

    paymentModeList,
    paymentModeSave,

    voucherList,
    deleteAccount,
    deleteGroup,

    accountListForContra,
    contraVoucherSave,
    voucherListByTag,

    contraVoucherEditByID,

    journalVoucherSave,
    multipleVoucherDataByID,
    accountListForJournal,

    generalVoucherSave,
    generalVoucherEditData,
    vendorList,
    customerList,

    stateList,
    accountListExceptCD,
    bankList,
    deletePaymentMode

};

export default accountService;